import React from 'react'
import PropTypes from 'prop-types'

// Components
import BidJsScripts from './bidJsScripts'
import Header from './header'
import Footer from './footer'

const Layout = ({ children, showSlices, uid }) => {
  return (
    <div className='flex min-h-screen flex-col bg-stone-100 text-stone-800 antialiased'>
      <Header showSlices={showSlices} uid={uid} />
      <main role='main' id='main'>
        {children}
      </main>
      <Footer />
      <BidJsScripts uid={uid} />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
